import { guardarReserva } from "./funciones/reserva.js";
import { initCalendar } from "./funciones/calendar.js";
import { eliminarParticipante, renderListaParticipantes, agregarParticipanteDesdeFormulario } from "./funciones/participantes.js";
import { showStep, prevStep, nextStep, goToStep, updateResumenSeleccion } from "./funciones/steps.js";
import { seleccionarHora } from "./funciones/hora_seleccionada.js";
import { initLugarActividad } from "./funciones/actividad_seleccionada.js";

// Hacer las funciones globales
window.goToStep = goToStep;
window.seleccionarHora = seleccionarHora;
window.eliminarParticipante = eliminarParticipante;
window.updateResumenSeleccion = updateResumenSeleccion;

// Inicialización
window.onload = () => {

    showStep(1);
    renderListaParticipantes();
    initCalendar();
    initLugarActividad();

    document.getElementById("btn-agregar-participante")
        .addEventListener("click", agregarParticipanteDesdeFormulario);

    document.getElementById("btn-prev")
        .addEventListener("click", prevStep);

    document.getElementById("btn-next")
        .addEventListener("click", nextStep);

    document.getElementById("btn-finish")
        .addEventListener("click", guardarReserva);

};